import DirectoryNewView from './DirectoryNewView';

export default DirectoryNewView;
